export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/83e791c702f67cc0242109b04d241be7.svg";